import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import styles from './ForgotPassword.module.css';
import routes from 'routes';
import { forgotPassword } from 'api/authApi';
import CustomInput from 'components/common/CustomInput/CustomInput';
import CustomButton, {
  defaultButtonStyle,
} from 'components/common/CustomButton';
import MetaTags from 'components/common/MetaTags';
import BackButton from 'components/auth/BackButton';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    email: '',
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formValues.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
      newErrors.email = 'Email address is invalid';
    }

    return newErrors;
  };

  const resetPassword = async () => {
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      try {
        const response = await forgotPassword(formValues.email);
        toast.success(response.data);
        navigate(`${routes.auth.resetPassword}?email=${formValues.email}`);
      } catch (e) {
        console.log('error: ', e);
        toast.error(e.response.data.title || e.response.data);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <MetaTags title="SplitFast | Reset password" />
      <BackButton navigate={navigate} />
      <div className={styles.forgotPasswordContainer}>
        <div className={styles.headerSection}>
          <h1 className="heading1">Reset Your Password</h1>
          <p className={styles.subtitle}>
            Enter your email address to receive a password reset code and regain
            access to your account.
          </p>
        </div>

        <div className={styles.inputSection}>
          <CustomInput
            label="Email"
            name="email"
            type="text"
            placeholder="Type your email"
            error={errors.email}
            onChange={handleInputChange}
            style={{ marginBottom: 20 }}
            inputStyle={{
              fontSize: '15px',
              height: '60px',
            }}
          />
        </div>

        <div className={styles.helpText}>
          <p>
            <strong>Note:</strong> If you have an account with this email
            address, you&apos;ll receive a password reset code. Please check your
            spam folder if you don&apos;t see the email in your inbox.
          </p>
        </div>

        <div className={styles.buttonSection}>
          <CustomButton
            disabled={loading}
            onClick={resetPassword}
            style={{
              ...defaultButtonStyle,
              width: '100%',
              maxWidth: 400,
            }}
          >
            {loading ? 'Sending...' : 'Send Reset Code'}
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
